import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import WishlistModal from './WishlistModal';
import { getTemplate } from '../../utils/helpers';
import { Button } from 'react-bootstrap';

class WishlistButton extends Component {
  state = {
    isWishlistModalOpen: false,
  };

  render() {
    const {additionalText, buttonType='button', customText} = this.props;

    return (
      <div>
        {
          this.state.isWishlistModalOpen
          ? (
            <WishlistModal
              {...this.props}
              isOpen={this.state.isWishlistModalOpen}
              onClose={() => this.setState({ isWishlistModalOpen: false })}
            />
          ) : null
        }
        {
          buttonType === 'link'
          ? (
            <Button 
              bsStyle={buttonType} 
              onClick={() => this.setState({isWishlistModalOpen: true})} 
            >
              {customText || "Click here to save your search"}
            </Button>
          )
          : (
          <button
            className="btn btn-primary"
            onClick={() => this.setState({ isWishlistModalOpen: true })}
            style={{
              backgroundColor: getTemplate(
                this.props.template,
                'saveSearchButton.backgroundColor'
              ),
              color: getTemplate(this.props.template, 'saveSearchButton.color'),
            }}
          >
            {customText ? this.props.customText : "Save Search"}
          </button>

          )
        }
        {additionalText ? <p>{additionalText}</p> : null}
      </div>
    );
  }
}

WishlistButton.propTypes = {
  additionalText: PropTypes.string,
  buttonType: PropTypes.oneOf(['button', 'link', undefined]),
  customText: PropTypes.string,
  searchResultsCount: PropTypes.number,
  template: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  const { template } = state.entities;
  return { template };
};

export default connect(mapStateToProps, {})(WishlistButton);
